import React, { useRef, useState } from 'react';

import { Divider, ListItemIcon, Menu, MenuItem } from '@mui/material';

export type BlockMenuItem = { label: string; icon: React.ReactNode; run: () => void; divider?: boolean; danger?: boolean; disabled?: boolean; reask?: boolean };

type BlockMenuProps = { label: string; title: string; icon: React.ReactNode; items: Array<BlockMenuItem> };

export default function BlockMenu({ label, title, icon, items }: BlockMenuProps) {
  const anchor = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  if (!items.length) return null;
  return (
    <>
      <button
        aria-expanded={open}
        aria-haspopup="menu"
        aria-label={label}
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        ref={anchor}
        title={title}
        type="button"
      >
        {icon}
      </button>
      <Menu anchorEl={anchor.current} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} onClick={(event) => event.stopPropagation()} onClose={() => setOpen(false)} open={open} transformOrigin={{ horizontal: 'right', vertical: 'top' }}>
        {items.map((item) => [
          item.divider ? <Divider key={`${item.label}-divider`} /> : null,
          <MenuItem
            dense
            disabled={item.disabled}
            key={item.label}
            onClick={() => {
              setOpen(false);
              item.run();
            }}
            sx={item.danger ? { color: 'error.main' } : undefined}
          >
            <ListItemIcon sx={item.danger ? { color: 'inherit' } : undefined}>{item.icon}</ListItemIcon>
            {item.label}
          </MenuItem>,
        ])}
      </Menu>
    </>
  );
}
